import React, { useState } from 'react';
import { I18n } from '@aws-amplify/core';
import { useHistory } from 'react-router-dom';
import { DownOutlined } from '@ant-design/icons';
import { Dropdown, type MenuProps } from 'antd';
import { Model } from '@/components/Settings/DataExtraction/ExtractionType/Model';
import { Container, IconWrapper, MenuItem } from './styles';
import { ExtractionType } from '@/components/Settings/DataExtraction/types';
import { PrimaryButton } from '@/components/ui/Button';

export function CreateDataExtractionButton() {
	const history = useHistory();
	const [isOpen, setIsOpen] = useState<boolean>(false);

	const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

	const actionHandlers: Record<ExtractionType, () => void> = {
		model: () => setIsModalOpen(true),
		file: () => history.push('/settings/data-extraction/file'),
		hierarchy: () => history.push('/settings/data-extraction/hierarchy')
	};

	function handleOnClick(e: React.MouseEvent<HTMLAnchorElement>): void {
		const typeModel = e.currentTarget.dataset.typeModel;

		if (typeModel && typeModel in actionHandlers) {
			actionHandlers[typeModel as ExtractionType]();
		}
		setIsOpen(false);
	}

	function handleOpenChange(value: boolean): void {
		setIsOpen(value);
	}

	const items: MenuProps['items'] = [
		{
			key: 'file',
			label: (
				<MenuItem data-type-model="file" onClick={handleOnClick}>
					{I18n.get('By file')}
				</MenuItem>
			)
		},
		{
			type: 'divider'
		},
		{
			key: 'hierarchy',
			label: (
				<MenuItem data-type-model="hierarchy" onClick={handleOnClick}>
					{I18n.get('By hierarchy')}
				</MenuItem>
			)
		},
		{
			type: 'divider'
		},
		{
			key: 'model',
			label: (
				<MenuItem data-type-model="model" onClick={handleOnClick}>
					{I18n.get('By model')}
				</MenuItem>
			)
		}
	];

	return (
		<Container>
			<Dropdown
				open={isOpen}
				menu={{ items }}
				placement="bottom"
				trigger={['click']}
				onOpenChange={handleOpenChange}
			>
				<PrimaryButton>
					{I18n.get('New extraction')}
					<IconWrapper $isOpen={isOpen}>
						<DownOutlined />
					</IconWrapper>
				</PrimaryButton>
			</Dropdown>
			<Model visible={isModalOpen} onCancel={() => setIsModalOpen(false)} />
		</Container>
	);
}
